/**
 * @fileoverview Options randomization context
 * @module screen-view-v2/context/OptionsRandomizationContext
 *
 * Carries the deterministic shuffle seed for `isRandomized` option lists.
 * Provided by the web-shell runtime engine with the VISITOR's seed (from the
 * second screen of a session onward), and by the editor's canvas node and
 * screen preview with the deterministic `preview:${screenId}`
 * (`PreviewOptionsRandomizationProvider`, ruling R-W11-5) so the owner judges
 * the same collapse and the same visible eight the visitor gets. Default `null`
 * means manifest order — SSR, the entry screen, and surfaces with no
 * funnel-screen identity never shuffle.
 */

import React from 'react';

export interface OptionsRandomization {
  /** Seed key for the deterministic shuffle, e.g. `${platformUserId}:${screenId}`. */
  seedKey: string;
}

export const OptionsRandomizationContext =
  React.createContext<OptionsRandomization | null>(null);

OptionsRandomizationContext.displayName = 'OptionsRandomizationContext';
